import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

export default function Login() {
  const { login } = useAuth();
  const navigate  = useNavigate();
  const [form, setForm]   = useState({ email:'', password:'' });
  const [error, setError] = useState('');
  const [busy, setBusy]   = useState(false);

  const submit = async (e) => {
    e.preventDefault(); setError(''); setBusy(true);
    try {
      const u = await login(form.email, form.password);
      navigate(u.role==='admin' ? '/admin' : '/dashboard');
    } catch(err) { setError(err.response?.data?.message || 'Login failed'); }
    finally { setBusy(false); }
  };

  return (
    <div style={{ minHeight:'100vh', display:'flex', alignItems:'center', justifyContent:'center', background:'linear-gradient(160deg,#0f0e17,#1a0a30)', padding:'40px 16px' }}>
      <div style={{ background:'var(--surface)', border:'1px solid var(--border2)', borderRadius:'var(--radius-lg)', padding:'48px 40px', width:'100%', maxWidth:420, boxShadow:'var(--shadow-lg)' }}>
        <div style={{ textAlign:'center', marginBottom:36 }}>
          <Link to="/" style={{ fontFamily:'var(--font-d)', fontSize:'1.6rem', fontWeight:700, color:'var(--text)' }}>
            Book<span style={{color:'var(--gold)'}}>Pub</span>
          </Link>
          <p style={{ color:'var(--text3)', marginTop:8, fontSize:'0.88rem' }}>Welcome back</p>
        </div>
        {error && <div className="alert alert-error">{error}</div>}
        <form onSubmit={submit}>
          <div className="form-group">
            <label>Email</label>
            <input className="form-control" type="email" value={form.email} onChange={e=>setForm({...form,email:e.target.value})} placeholder="you@example.com" required />
          </div>
          <div className="form-group">
            <label>Password</label>
            <input className="form-control" type="password" value={form.password} onChange={e=>setForm({...form,password:e.target.value})} placeholder="Your password" required />
          </div>
          <button type="submit" className="btn btn-gold" style={{width:'100%',justifyContent:'center',marginTop:8}} disabled={busy}>
            {busy ? 'Signing in…' : 'Sign In'}
          </button>
        </form>
        <p style={{ textAlign:'center', color:'var(--text3)', fontSize:'0.88rem', marginTop:24 }}>
          No account? <Link to="/register" style={{color:'var(--gold)',fontWeight:700}}>Sign up free</Link>
        </p>
      </div>
    </div>
  );
}
